/**
 * Define backends urls
 */
import IS_CLIENT_RENDERED from "./isClientRendered";

export const PRODUCTION_URL = "https://www.casemasters.com";
const STAGING_URL = "https://www.casemasters.xyz";
export const DEVELOP_URL = "https://develop.casemasters.xyz";
const APPLE_URL = "https://apple.casemasters.xyz";
const BANANA_URL = "https://banana.casemasters.xyz";
const LOCAL_URL = "https://localhost:4424";

const PRODUCTION_API_URL = "https://api.casemasters.com";
const DEVELOP_API_URL = "https://api.casemasters.xyz";

const PRODUCTION_MIXPANEL_TOKEN = "3cbafc0df715711966e380dca9668b62";
const DEVELOP_MIXPANEL_TOKEN = "ed02480300628499d43287438d2abb00";

export const LANDING_PAGE_URL = "https://landing.casemasters.com";

const PRODUCTION_FIREBASE_NOTIFCATIONS_DB_URL = "https://casemasters-notifications.firebaseio.com/";
const DEVELOP_FIREBASE_NOTIFCATIONS_DB_URL = "https://casemasters-notifications-develop.firebaseio.com/";

export const RAVEN_CONFIG_PROD_URL = "https://ace808b2eeb745acb670f5cd559f3e68@sentry.io/275472";
export const RAVEN_CONFIG_DEV_URL = "https://9f58bf73953f425b8246c1f1620a97a5@sentry.io/275126";

const getOrigin = () => {
  if (IS_CLIENT_RENDERED) {
    return window.location.origin;
  }
  return process.env.ORIGIN;
};

const origin = getOrigin();

export let API_URL = "";
export let IDS_URL = "";
export let CLIENT_ID = "";
export let MIXPANEL_TOKEN = "";
export let ENVIROMENT = "";
export let FIREBASE_NOTIFCATIONS_DB_URL = "";
export let RAVEN_CONFIG_URL = "";

switch (origin) {
  case PRODUCTION_URL:
    ENVIROMENT = "PRODUCTION";
    API_URL = PRODUCTION_API_URL;
    CLIENT_ID = "caseMasters";
    MIXPANEL_TOKEN = PRODUCTION_MIXPANEL_TOKEN;
    FIREBASE_NOTIFCATIONS_DB_URL = PRODUCTION_FIREBASE_NOTIFCATIONS_DB_URL;
    RAVEN_CONFIG_URL = RAVEN_CONFIG_PROD_URL;
    break;

  case STAGING_URL:
    ENVIROMENT = "STAGING";
    API_URL = DEVELOP_API_URL;
    CLIENT_ID = "caseMastersStaging";
    MIXPANEL_TOKEN = DEVELOP_MIXPANEL_TOKEN;
    FIREBASE_NOTIFCATIONS_DB_URL = DEVELOP_FIREBASE_NOTIFCATIONS_DB_URL;
    RAVEN_CONFIG_URL = RAVEN_CONFIG_DEV_URL;
    break;

  case DEVELOP_URL:
    ENVIROMENT = "DEVELOP";
    API_URL = DEVELOP_API_URL;
    CLIENT_ID = "caseMastersDevelop";
    MIXPANEL_TOKEN = DEVELOP_MIXPANEL_TOKEN;
    FIREBASE_NOTIFCATIONS_DB_URL = DEVELOP_FIREBASE_NOTIFCATIONS_DB_URL;
    RAVEN_CONFIG_URL = RAVEN_CONFIG_DEV_URL;
    break;

  case LOCAL_URL:
    ENVIROMENT = "LOCAL";
    API_URL = DEVELOP_API_URL;
    CLIENT_ID = "caseMastersLocal";
    MIXPANEL_TOKEN = DEVELOP_MIXPANEL_TOKEN;
    FIREBASE_NOTIFCATIONS_DB_URL = DEVELOP_FIREBASE_NOTIFCATIONS_DB_URL;
    RAVEN_CONFIG_URL = RAVEN_CONFIG_DEV_URL;
    break;

  case APPLE_URL:
    ENVIROMENT = "APPLE";
    API_URL = DEVELOP_API_URL;
    CLIENT_ID = "caseMastersApple";
    MIXPANEL_TOKEN = DEVELOP_MIXPANEL_TOKEN;
    FIREBASE_NOTIFCATIONS_DB_URL = DEVELOP_FIREBASE_NOTIFCATIONS_DB_URL;
    RAVEN_CONFIG_URL = RAVEN_CONFIG_DEV_URL;
    break;

  case BANANA_URL:
    ENVIROMENT = "BANANA";
    API_URL = DEVELOP_API_URL;
    CLIENT_ID = "caseMastersBanana";
    MIXPANEL_TOKEN = DEVELOP_MIXPANEL_TOKEN;
    FIREBASE_NOTIFCATIONS_DB_URL = DEVELOP_FIREBASE_NOTIFCATIONS_DB_URL;
    RAVEN_CONFIG_URL = RAVEN_CONFIG_DEV_URL;
    break;

  default:
    throw new Error("Unknown Hosting Location");
}



// WEBPACK FOOTER //
// ./src/util/constants.js